import React from 'react';
import('./Contact.css')

const Contact = () => {
    return (
        <div>
            <h2 className='service-title'>Call us or book your appointment today

            </h2>

            <div className='contact'>
                <h4><span>Opening Hours:</span> Mon-Sat: 9:00 A.M - 5:00 PM Sun: Closed</h4>
                <br />

                <h4><span>Call Us:</span> +8801788266110</h4>
                <h4><span>Email:</span> dental.care@gmail.com</h4>
                <h4><span>Address:</span> Dhanmondi 27, Dhaka</h4>

                <h4><span>Facebook:</span>https://www.facebook.com/mehedihasan.limon.7</h4>
            </div>
            <br />
            <br />
            <br />
            <br />
            <br />
            <br />
            <br />
            <br />
            <br />
            <br />
            <br />
            <br />
            <br />
            <br />
            <br />
            <br />
        </div>
    );
};

export default Contact;